import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, MapPin, Phone, Search } from "lucide-react";
import { SEOHead } from "../components/SEOHead";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function NotFoundPage() {
  const [cities, setCities] = useState([]);
  useEffect(() => {
    fetch(`${API}/cities`).then(r => r.json()).then(c => setCities(c.slice(0, 6))).catch(() => {});
  }, []);

  return (
    <div data-testid="not-found-page" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <SEOHead title="Page Not Found" description="The page you're looking for doesn't exist." noindex={true} />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-2xl w-full text-center py-24">
        <div className="font-['Outfit'] text-[120px] md:text-[160px] font-black text-[#E60000]/10 leading-none mb-[-30px]">404</div>
        <h1 className="font-['Outfit'] text-3xl md:text-4xl font-bold text-white mb-4">Page Not Found</h1>
        <p className="text-white/40 text-base mb-10">The page you're looking for doesn't exist or has been moved.</p>

        <div className="flex flex-wrap gap-4 justify-center mb-16">
          <Link to="/" className="flex items-center gap-2 bg-[#E60000] hover:bg-[#FF3B30] text-white px-6 py-3 font-semibold text-sm transition-colors"><Home size={16} />Go Home</Link>
          <a href="tel:+16472499977" className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white px-6 py-3 font-semibold text-sm transition-colors"><Phone size={16} />Call Dispatch</a>
        </div>

        {cities.length > 0 && (
          <div>
            <p className="text-white/30 text-xs font-bold uppercase tracking-widest mb-4">Explore Our Service Areas</p>
            <div className="flex flex-wrap gap-3 justify-center">
              {cities.map(c => (
                <Link key={c.slug} to={`/cities/${c.slug}`} className="flex items-center gap-2 bg-[#141414] border border-white/5 hover:border-[#E60000]/20 px-4 py-2 text-white/60 hover:text-white text-sm transition-colors">
                  <MapPin size={12} className="text-[#E60000]" />{c.name}
                </Link>
              ))}
            </div>
          </div>
        )}

        <div className="mt-12 flex flex-wrap gap-6 justify-center text-sm">
          <button onClick={() => document.getElementById("riders")?.scrollIntoView({ behavior: "smooth" })} className="text-white/30 hover:text-white transition-colors">Riders</button>
          <button onClick={() => document.getElementById("drivers")?.scrollIntoView({ behavior: "smooth" })} className="text-white/30 hover:text-white transition-colors">Drivers</button>
          <button onClick={() => document.getElementById("businesses")?.scrollIntoView({ behavior: "smooth" })} className="text-white/30 hover:text-white transition-colors">Businesses</button>
          <Link to="/privacy" className="text-white/30 hover:text-white transition-colors">Privacy</Link>
          <Link to="/terms" className="text-white/30 hover:text-white transition-colors">Terms</Link>
        </div>
      </motion.div>
    </div>
  );
}
